import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import logo from '../../../assets/img/reactlogo.png';
const today = new Date().toISOString().split('T')[0];
// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: '#ffffff'
  },
  section: {
    marginBottom: 5
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5
  },
  headerText: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: "center"
  },
  image: {
    width: 100
  },
  provider: {
    height: 50
  },
  date: {
    fontSize: 12,
    textAlign: 'right'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0'
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableCellHeader: {
    margin: 6,
    fontSize: 11,
    fontWeight: "bold"
  },
  tableCell: {
    margin: 6,
    fontSize: 11
  },
  footerContainer: {
    marginTop: 20
  },
  companyMainText: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  companyText: {
    fontSize: 9
  },
  totalCost: {
    fontSize: 12,
    fontWeight: 'bold'
  },
});

function Orders() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userMobile, setUserMobile] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [viewData, setViewData] = useState(false);
  const [viewReject, setViewReject] = useState(false);
  const [uploadData, setUploadData] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const handleClose = () => {
    setViewData(false);
    setViewReject(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { status, start_date, end_date } = e.target;
    let rechargeData = {
      userMobile,
      status: status.value,
      start_date: start_date.value,
      end_date: end_date.value,
    };
    getData(rechargeData);
  };

  const price = (price, discount) => {
    return price - (price * discount / 100);
  };

  const totalPrice = data?.data?.[viewIndex]?.cartData.reduce((sum, item) => {
    return sum + (price(item.price, item.discountInPercent) * item.quantity);
  }, 0);

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      userMobile: pageData.userMobile,
      status: pageData.status,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/orderHistory", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleRejectSubmit = async (e1) => {
    e1.preventDefault();
    const { comment } = e1.target;
    const { options, e } = viewReject;
    const { name, value } = e.target;
    options.editorCallback(e.target.value);
    const response = await axios.post("/action/changeOrderData", { [name]: value, orderId: options.rowData._id, comment: comment.value, userId: options.rowData.user_id });
    const { status, message, data } = response.data;
    if (status) {
      toast(message);
      handleClose();
    }
  };

  const viewOrder = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const ChangeStatus = async (options, e) => {
    try {
      options.editorCallback(e.target.value);
      const { name, value } = e.target;
      if (value == "rejected") {
        setViewReject({ options, e });
      }
      else {
        const response = await axios.post("/action/changeOrderData", { [name]: value, orderId: options.rowData._id, userId: options.rowData.user_id });
        const { status, message, data } = response.data;
        if (status) {
          toast(message);
          handleClose();
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const PrintPDF = () => (
    typeof window !== 'undefined' && (<Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.headerContainer}>
            <Image style={styles.image} src={logo} />
            <Text style={styles.headerText}>Order Summary</Text>

          </View>
          <View>
            <Text style={styles.companyMainText}>Pargati online service PVT LTD, SCO 832, 2nd floor, Cabin no. 10, NAC Manimajra, Chandigah</Text>
            <Text style={styles.companyText}>Office Working Days: Monday To Saturday</Text>
            <Text style={styles.companyText}>Timing: 10:00 AM To 6:00 PM</Text>
            <Text style={styles.companyText}>Help Line: 01724049681</Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Sold To</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Ship To</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Pargati online service PVT LTD</Text>
              <Text style={styles.tableCell}>CO 832, 2nd floor,</Text>
              <Text style={styles.tableCell}>Cabin no. 10, NAC Manimajra,</Text>
              <Text style={styles.tableCell}>Chandigah</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{data?.data?.[viewIndex]?.firstName} {data?.data?.[viewIndex]?.lastName}</Text>
              <Text style={styles.tableCell}>{data?.data?.[viewIndex]?.address}</Text>
              <Text style={styles.tableCell}>{data?.data?.[viewIndex]?.city} ({data?.data?.[viewIndex]?.state}) - {data?.data?.[viewIndex]?.postcode}</Text>
              <Text style={styles.tableCell}>Phone: {data?.data?.[viewIndex]?.phone}</Text>
            </View>
          </View>
        </View>
        <Text style={styles.totalCost}>Products Detail</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>#</Text></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>SKU</Text></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Product Name</Text></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Price</Text></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Quantity</Text></View>
          </View>
          {(data.data[viewIndex].cartData).map((data, index) => (
            <View style={styles.tableRow}>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{index + 1}</Text></View>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{data.sku}</Text></View>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{data.productName}</Text></View>
              <View style={styles.tableCol}><Text style={styles.tableCell}>Rs {price(data.price, data.discountInPercent)}</Text></View>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{data.quantity}</Text></View>
            </View>
          ))}
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}></View>
            <View style={styles.tableColHeader}></View>
            <View style={styles.tableColHeader}></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Total Price</Text></View>
            <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Rs {totalPrice.toFixed(2)}</Text></View>
          </View>
        </View>
      </Page>
    </Document>)
  );

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    rowData[field] = newValue;
  };

  const cellEditor = (options) => {
    return (
      <select name="status" value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>
    );
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserMobile("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Order Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />

                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserMobile(item.mobile);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Status</label>
                    <select class="form-control" name="status">
                      <option value="">All</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Order History
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="full_name"
                        header="Full Name"
                        sortable
                        body={(rowData) => <span data-label="User">{rowData?.firstName} {rowData?.lastName}</span>}
                      />
                      <Column
                        field="email"
                        header="Email"
                        sortable
                        body={(rowData) => <span data-label="Email">{rowData.email}</span>}
                      />
                      <Column
                        field="phone"
                        header="Phone"
                        sortable
                        body={(rowData) => <span data-label="Phone">{rowData?.phone}</span>}
                      />
                      <Column
                        field="paymentType"
                        header="PaymentType"
                        sortable
                        body={(rowData) => <span data-label="PaymentType">{rowData.paymentType}</span>}
                      />
                      <Column
                        field="paymentStatus"
                        header="PaymentStatus"
                        sortable
                        body={(rowData) => <span data-label="PaymentStatus">{rowData.paymentStatus}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{capitalizeWords(rowData.status)}</span>}
                        editor={(options) => cellEditor(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => viewOrder(rowIndex)}>View</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={viewData} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>ORDER Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            (data && data.data && (Object.entries(data.data).length > 0)) && (
              <>
                <ul className="showData">
                  {Object.entries(data.data[viewIndex]).map(([key, value]) => (
                    (!["", false, true, null].includes(value) && !["_id", "cartData", "__v", "created_at", "updated_at"].includes(key) && (value.toString()).indexOf("_") == "-1") && (
                      <li key={key}>
                        <strong>{addSpaceBetweenCases(key)}:</strong>
                        <div>{value}</div>
                      </li>
                    )
                  ))}
                </ul>
                <hr />
                <h4>Products Detail</h4>
                <hr />
                <table className="table">
                  <tr>
                    <th>#</th>
                    <th>SKU</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                  </tr>
                  {(data.data[viewIndex].cartData).map((data, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{data.sku}</td>
                      <td>{data.productName}</td>
                      <td>₹{price(data.price, data.discountInPercent)}</td>
                      <td>{data.quantity}</td>
                    </tr>
                  ))}
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Total Price</th>
                    <th>₹{totalPrice.toFixed(2)}</th>
                  </tr>
                </table>
              </>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {typeof window !== 'undefined' && viewData && (
            <PDFDownloadLink className="btn btn-primary" document={<PrintPDF />} fileName="mypdf.pdf">
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 'Print'
              }
            </PDFDownloadLink>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={viewReject} onHide={handleClose} centered size={'s'} backdrop="static">
        <Form onSubmit={handleRejectSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Reject Reasion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row">
              <div class="col-lg-12">
                <textarea className="form-control" name="comment"></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Reject
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Orders;
